import script from "./GiveawayForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GiveawayForm.vue?vue&type=script&setup=true&lang=js"

import "./GiveawayForm.vue?vue&type=style&index=0&id=4e238b1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e238b1e"]])

export default __exports__